import { render } from "./UpdateMessage.vue?vue&type=template&id=b484543a&scoped=true"
import script from "./UpdateMessage.vue?vue&type=script&lang=js"
export * from "./UpdateMessage.vue?vue&type=script&lang=js"

import "./UpdateMessage.vue?vue&type=style&index=0&id=b484543a&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-b484543a"

export default script